/* eslint-disable import/no-anonymous-default-export */
import base from './base'

export default {
	gets(companyID) {
		return base.get(`/api-con/company/${companyID}/posPdv/gets`)
	}
}